import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useSubFormIsValidSync } from '@hooks/use-sub-form-is-valid-sync';
import {
  ShippingAddress,
  ShippingAddressWithNameSchema,
  ShippingAddressPhoneNumberValidation,
} from '@web/components';
import { useReporter } from '../../reporter';
import {
  addressCompleted,
  phoneNumberCompleted,
  smsUpdateToggled,
} from './events';

export const ShippingAddressForm = ({
  labelFirstName,
  labelLastName,
  labelAddress,
  labelApt,
  labelZipCode,
  labelCity,
  labelState,
  stateOptions,
  labelPhoneNumber,
  labelSMSUpdates,
  labelSMSTerms,
}) => {
  const {
    watch,
    formState: { touchedFields, dirtyFields },
  } = useFormContext();
  const isValidForm = useSubFormIsValidSync(ShippingAddressWithNameSchema);
  const reporter = useReporter();
  const phoneNumberValue = watch('phoneNumber');
  const smsUpdateValue = watch('smsUpdates');
  const isValidPhone =
    ShippingAddressPhoneNumberValidation.isValidSync(phoneNumberValue);

  useEffect(() => {
    if (isValidForm) {
      reporter.tag(addressCompleted());
    }
  }, [isValidForm, reporter]);

  useEffect(() => {
    if (isValidPhone) {
      reporter.tag(phoneNumberCompleted());
    }
  }, [isValidPhone, reporter]);

  useEffect(() => {
    if (touchedFields['smsUpdates'] || dirtyFields['smsUpdates']) {
      reporter.tag(smsUpdateToggled(smsUpdateValue));
    }
  }, [smsUpdateValue, dirtyFields, touchedFields, reporter]);

  return (
    <ShippingAddress
      labelFirstName={labelFirstName}
      labelLastName={labelLastName}
      labelAddress={labelAddress}
      labelApt={labelApt}
      labelZipCode={labelZipCode}
      labelCity={labelCity}
      labelState={labelState}
      stateOptions={stateOptions}
      labelPhoneNumber={labelPhoneNumber}
      labelSMSUpdates={labelSMSUpdates}
      labelSMSTerms={labelSMSTerms}
    />
  );
};
ShippingAddressForm.displayName = 'ShippingAddressForm';
ShippingAddressForm.propTypes = {
  labelFirstName: PropTypes.string.isRequired,
  labelLastName: PropTypes.string.isRequired,
  labelAddress: PropTypes.string.isRequired,
  labelApt: PropTypes.string.isRequired,
  labelZipCode: PropTypes.string.isRequired,
  labelCity: PropTypes.string.isRequired,
  stateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  ),
  labelState: PropTypes.string.isRequired,
  labelPhoneNumber: PropTypes.string.isRequired,
  labelSMSUpdates: PropTypes.string.isRequired,
  labelSMSTerms: PropTypes.string.isRequired,
};
